<div class="steps-container">
<h2 class="main-title" [innerHTML]="data?.title"></h2>

  

  <div class="steps-wrapper">
    <div
      class="step-item"
      *ngFor="let step of data?.steps; let last = last"
    >
      <div class="icon-column">
        <div class="step-icon">
          <i [class]="step.icon"></i>
        </div>
        <div
          class="icon-line"
          *ngIf="!last"
        ></div>
      </div>

      <div class="text-column">
        <h3 class="step-title">{{ step.title }}</h3>
        <p class="step-description">{{ step.description }}</p>
      </div>
    </div>
  </div>
</div>
